function applyChartTheme(theme) {
    if (typeof Chart === 'undefined') return;
    const isDark = theme === 'dark';
    const tickColor  = isDark ? '#adb5bd' : '#666666';
    const gridColor  = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)';
    const tooltipBg  = isDark ? '#343a40' : '#ffffff';
    const tooltipText = isDark ? '#dee2e6' : '#333333';
    Chart.defaults.color = tickColor;
    Chart.defaults.borderColor = gridColor;
    Chart.defaults.plugins.tooltip.backgroundColor = tooltipBg;
    Chart.defaults.plugins.tooltip.titleColor = tooltipText;
    Chart.defaults.plugins.tooltip.bodyColor = tooltipText;
    document.dispatchEvent(new CustomEvent('themeChanged', { detail: { theme } }));
}

$(function () {
    const saved = localStorage.getItem('theme') || 'light';
    applyChartTheme(saved);

    $(document).on('click', '#theme-toggle', function () {
        const current = document.documentElement.getAttribute('data-bs-theme') || 'light';
        const next = current === 'light' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-bs-theme', next);
        localStorage.setItem('theme', next);
        applyChartTheme(next);
    });
});
